module.exports = __webpack_public_path__ + "static/img/CCHUB.39d6cd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CCHUB.png
// module id = zz1W
// module chunks = 0